import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type TASProgramInstance from 'tio-data/models/tas-program-instance';
import type StoreService from 'ember-data/store';

interface Params {
  tas_program_instance_id: string;
}

export default class AuthenticatedAdminTasProgramsRoute extends Route {
  @service declare store: StoreService;

  includes = [
    'tas-applications.tas-courses',
    'tas-applications.comments.person',
    'tas-applications.tas-assets.attachments',
    'tas-applications.tags',
    'tas-program-template',
    'tas-program-template.tas-field-options',
    'employee.person',
    'employee.company',
    'employee.company.company-setting',
    'employee.company.comments',
    'employee.tas-participant',
    'tas-assets.attachments',
    'comments',
  ];

  // @ts-expect-error - Route model signature mismatch with Ember Route types
  async model(params: Params): Promise<TASProgramInstance> {
    const instance = (await this.store.findRecord(
      'tas-program-instance',
      params.tas_program_instance_id,
      {
        include: this.includes.join(','),
        reload: true,
      }
    )) as TASProgramInstance;

    await instance.loadHistory();

    return instance;
  }
}
